import React, {
  createContext,
  useContext,
  useCallback,
  type ReactNode,
} from 'react'

type BalanceContextType = {
  refetchBalances: () => void
  setRefetchFunction: (refetchFn: () => void) => void
}

const BalanceContext = createContext<BalanceContextType | undefined>(undefined)

export const useBalanceContext = () => {
  const context = useContext(BalanceContext)
  if (!context) {
    throw new Error('useBalanceContext must be used within a BalanceProvider')
  }
  return context
}

export const BalanceProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  let refetchFunction: (() => void) | null = null

  const setRefetchFunction = useCallback((refetchFn: () => void) => {
    refetchFunction = refetchFn
  }, [])

  const refetchBalances = useCallback(() => {
    if (refetchFunction) {
      refetchFunction()
    }
  }, [])

  const value: BalanceContextType = {
    refetchBalances,
    setRefetchFunction,
  }

  return (
    <BalanceContext.Provider value={value}>{children}</BalanceContext.Provider>
  )
}
